export { }
declare global {
    interface Array<T> {
        map2<U>(callbackfn: (value: T, value2: T | undefined) => U, thisArg?: any): U[];
    }

    interface String {
        toWordPrice(): String
    }

    interface Date {
        ago(): String
    }
}


if (!Array.prototype.map2) {
    Array.prototype.map2 = function <T, U>(callbackfn: (value: T, value2: T | undefined) => U, thisArg?: any): U[] {
        let ar: U[] = []
        for (let i = 0; i < this.length;) {
            ar.push(callbackfn(this[i], this[i + 1]))
            i += 2
        }

        return ar
    }
}



String.prototype.toWordPrice = function (): String {
    let size = this.length
    let number = Number.parseInt(this.toString())
    if (size <= 3) {
        return `${number}`
    } else if (size > 3 && size <= 6) {
        return `${number / 1000}` + " هزار"

    } else if (size > 6 && size <= 9) {
        return `${number / 1000000}` + " میلیون"

    } else if (size > 9 && size <= 12) {
        return `${number / 1000000000}` + " میلیارد"

    } else if (size > 12 && size <= 15) {
        return `${number / 1000000000000}` + " بیلیون"

    } else if (size > 15 && size <= 18) {
        return `${number / 1000000000000000}` + " بیلیارد"

    } else {
        return `${number / 1000000000000000000}` + " تریلیون"

    }
}

Date.prototype.ago = function (): String {

    let now = new Date()

    let seconds = Math.floor((now.getTime() - this.getTime()) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(hours / 24);

    if (minutes < 120) {
        // ثانیه قبل
        return  "لحظاتی پیش"
    } else if (hours <= 48) {
        // دقیقه قبل
        return  "ساعاتی پیش"
    } else if (days <= 10) {
        // ساعت قبل
        return  "همین هفته"
    } else if (days > 11 && days <= 22) {
        // روز قبل
        return  "هفته پیش"
    } else if (days > 22 && days <= 40) {
        return  "همین ماه"
    } else if (days > 40 && days <= 60) {
        return  "ماه گذشته"
    } else {
        return "چند ماه پیش"
    }



}
